import { faker } from '@faker-js/faker';
import { stableCertificateId } from './certificateStandards';

export type CertificateInstituteRecord = {
  id: string;
  /** Numeric id aligned with Mirage/SCM institute list (stable per generated row). */
  apiId: number;
  label: string;
};

const CERTIFICATE_INSTITUTE_MOCK_COUNT = 99;
const CERTIFICATE_INSTITUTE_FAKER_SEED = 202_604_23;

faker.seed(CERTIFICATE_INSTITUTE_FAKER_SEED);

function generateCertificateInstituteRecords(): CertificateInstituteRecord[] {
  const usedIds = new Set<string>();
  const rows: CertificateInstituteRecord[] = [];

  for (let i = 0; i < CERTIFICATE_INSTITUTE_MOCK_COUNT; i++) {
    const label = faker.company.name();
    const id = stableCertificateId(label, i, usedIds);
    rows.push({ id, apiId: i + 1, label });
  }

  return rows;
}

export const CERTIFICATE_INSTITUTE_RECORDS = generateCertificateInstituteRecords();

/**
 * Deterministic, additive fixture entries for the DL-65183 epic (Testmo folder dl-59415 —
 * Institute/Standards long-name hover tooltip). The generated pool above has no guaranteed
 * long-or-short outlier, which is what the truncation (DL-65184) and negative-control (DL-65186)
 * specs need. Appended — never inserted — after the generated pool so no other spec's option
 * count/order/index assumptions shift; `apiId`s are picked well outside the generated `1..99`
 * range to avoid collision. Kept in lockstep with the identical literals duplicated in
 * `frontend/e2e/src/commons/facility-certificates/certificateOptionTooltip.helpers.ts` (`e2e/` and
 * `src/` are separate TS programs — see that file's header).
 */
export const CERTIFICATE_INSTITUTE_TOOLTIP_FIXTURE = {
  long: {
    id: 'tooltip-fixture-long-institute',
    apiId: 9901,
    label:
      'Delogue Automated Testing Institute For Extended International Certification And Compliance Verification Services',
  },
  short: {
    id: 'tooltip-fixture-short-institute',
    apiId: 9902,
    label: 'QCX',
  },
} as const;

CERTIFICATE_INSTITUTE_RECORDS.push(
  CERTIFICATE_INSTITUTE_TOOLTIP_FIXTURE.long,
  CERTIFICATE_INSTITUTE_TOOLTIP_FIXTURE.short
);

export function getCertificateInstitutes(): CertificateInstituteRecord[] {
  return CERTIFICATE_INSTITUTE_RECORDS;
}
